import { render, staticRenderFns } from "./CabinetHome.vue?vue&type=template&id=a323ffc0&scoped=true&"
import script from "./CabinetHome.vue?vue&type=script&lang=js&"
export * from "./CabinetHome.vue?vue&type=script&lang=js&"
import style0 from "./CabinetHome.vue?vue&type=style&index=0&id=a323ffc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a323ffc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a323ffc0')) {
      api.createRecord('a323ffc0', component.options)
    } else {
      api.reload('a323ffc0', component.options)
    }
    module.hot.accept("./CabinetHome.vue?vue&type=template&id=a323ffc0&scoped=true&", function () {
      api.rerender('a323ffc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/CabinetHome.vue"
export default component.exports